"use client";
import * as React from "react";
const SvgArrowUpwardSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m0 8 1.41 1.41L7 3.83V16h2V3.83l5.58 5.59L16 8 8 0z" }));
export {
  SvgArrowUpwardSharp as default
};
